import { GatsbyImage } from 'gatsby-plugin-image';
import { InlineWidget } from 'react-calendly';

import { Container, Overlay, Section } from '../../common';

const CalendarFull = ({ page, sanity }) => {
  const { colors, form } = sanity;

  return (
    <Section idName="calendar-full" padding="none">
      <div className="relative w-full">
        {/* Background Image + Overlay */}
        <div className="absolute inset-0">
          <GatsbyImage
            image={form?.bgImg?.asset?.gatsbyImageData}
            alt={form?.bgImg?.alt}
            className="object-cover w-full h-full"
            loading="eager"
          />
          <Overlay
            isGradient
            bgColor={colors?.neutral?.default}
            bgColorHover={colors?.neutral?.dark}
            bgColorStart={colors?.neutral?.dark}
            bgColorMid={colors?.neutral?.default}
            bgColorEnd={colors?.neutral?.light}
          />
        </div>

        {/* Calendar Container */}
        <Container padding="none" classes="relative w-full max-w-7xl px-4 lg:px-0 py-24 mx-auto">
          <div className="">
            <InlineWidget
              url="https://calendly.com/robin-wiener-getrealconsultants/15-minute-intro-chat?primary_color=f59e0b"
              styles={{ minWidth: '320px', height: '900px' }}
              className="w-full h-full"
            />
          </div>
        </Container>
      </div>
    </Section>
  );
};

export { CalendarFull };
